<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center"
    :class="css"
  >
    <p><i class="ph ph-spinner spinner" /></p>
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingData',

  props: {
    text: {
      type: String,
      default: 'Carregando dados ...',
    },
    css: {
      type: String,
      default: 'h-100',
    },
  },
}
</script>
